import { ProjectRuntimes } from '../config/types/runtimes';

export const isJestRuntime =
  process.env.REACT_APP_RUNTIME === ProjectRuntimes.JEST;

export const isDev = process.env.NODE_ENV === 'development';
